import { Box, Button, Menu, MenuItem } from "@mui/material";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddBusinessIcon from "@mui/icons-material/AddBusiness";
export const getHeaderConfig = () => {
  return [
    {
      label: "Group Code",
      id: "groupCode",
    },
    {
      label: "Name",
      id: "name",
    },
    {
      label: "Description",
      id: "description",
    },
    {
      label: "Specification",
      id: "spec",
      render: (data) => {
        return data?.specificationId?.name;
      },
    },
    {
      label: "Actions",
      id: "action",
      render: (data, onClick) => {
        return (
          <Box
            sx={{ display: "flex", flexWrap: "wrap", justifyContent: "center" }}
          >
            <EditIcon
              color="info"
              onClick={() => onClick(data, "edit")}
              sx={{ cursor: "pointer" }}
            />
            <DeleteIcon
              color="error"
              onClick={() => onClick(data, "delete")}
              sx={{ cursor: "pointer" }}
            />
            <AddBusinessIcon
              color="success"
              onClick={() => onClick(data, "addStore")}
              sx={{ cursor: "pointer" }}
            />
          </Box>
        );
      },
    },
  ];
};
